// extracted by mini-css-extract-plugin
export default {"component":"DiscountByStylist_component__QRujI","tableHeader":"DiscountByStylist_tableHeader__gVHGA","boldFooterRow":"DiscountByStylist_boldFooterRow__vVVWC"};